// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3233":"b8b9d34c078c1a6a","9631":"e6a3d1cf66f0ddf4"}[chunkId] + ".css";
};